import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IsSidebarOpenService {
  sidebarOpen = true;

  private _isSidebarOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isSidebarOpen: Observable<boolean> = this._isSidebarOpen.asObservable();

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this._isSidebarOpen.next(this.sidebarOpen);
  }

  closeSidebar() {
    this.sidebarOpen = false;
    this._isSidebarOpen.next(this.sidebarOpen);
  }

  openSidebar() {
    this.sidebarOpen = true;
    this._isSidebarOpen.next(this.sidebarOpen);
  }
}
